export default "__VITE_ASSET__DhPbhqCD__"